module.exports = __webpack_public_path__ + "static/media/small-header.d6e38d44.svg";